// Singleton for validating specific types of data:
export default class BCMSValidate {

  // :: STRING -> BOOLEAN
  // Returns BOOLEAN for if given value is not "empty" - i.e., contains at least 1 non-whitespace character:
  static isNotEmpty (value) {
    var pattern =/\S+/;
    return pattern.test(value);
  }

  // :: STRING -> BOOLEAN
  // Returns BOOLEAN for if given value is a number:
  static isNumber (value) {
   var pattern = /^-?\d+\.?\d*$/;
   return pattern.test(value);
  }


  // :: STRING -> BOOLEAN
  // Returs BOOLEAN for if given value is formatted as an email:
  static isEmail (value) {
    var pattern =/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return pattern.test(value);
  }

  // :: STRING -> BOOLEAN
  // Returns BOOLEAN for if given value is a date formatted as mm/dd/yyyy
  // NOTE: http://regexlib.com/REDetails.aspx?regexp_id=17
  static isDate (value) {
   var pattern = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
   return pattern.test(value);
  }

  // :: STRING -> BOOLEAN
  // Returns BOOLEAN for if given value is formatted as USD currency:
  // NOTE: http://regexlib.com/REDetails.aspx?regexp_id=130
  static isCurrency(value) {
    var pattern = /^\$?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(\.[0-9][0-9])?$/;
    return pattern.test(value);
  }


  // :: STRING -> BOOLEAN
  // Returns BOOLEAN for if given value is formated as a phone number:
  // NOTE: http://regexlib.com/REDetails.aspx?regexp_id=27
  static function (value) {
    var pattern = /((\(\d{3}\) ?)|(\d{3}-))?\d{3}-\d{4}/;
    return pattern.test(value);
  }

}
